import axios from "axios";
import { useAuthStore } from "../app/authStore";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:4000/api",
  timeout: 15000
});

api.interceptors.request.use((config) => {
  const { token, selectedPartnerId } = useAuthStore.getState();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (selectedPartnerId) {
    config.headers["X-Partner-Id"] = selectedPartnerId;
  }

  return config;
});

export function errorMessage(error: unknown) {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message || error.message;
  }

  return error instanceof Error ? error.message : "Неизвестная ошибка";
}
